import React, { useMemo, useState } from "react";
import {
  getOperationalRoleToDisplay,
  sortByOperationalRole,
  userHasOneOfTheseRoles,
} from "../../services/backofficeUserService";
import ContentBox from "../ContentBox/ContentBox";
import _ from "lodash";
import { BackofficeUser, Roles } from "../../types/BackofficeUser";
import { useBackofficeUser } from "../../provider/BackofficeUserProvider";
import LegalbirdAutoComplete from "../AutoComplete/LegalbirdAutoComplete";
import ButtonLoading from "../Button/ButtonLoading";
import { Navigate, useNavigate } from "react-router-dom";
import { useCurrentUser } from "../../provider/CurrentUserProvider";
import { useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../../services/ReactQuery/reactQueryService";
import { AutoCompleteOptionWithValue } from "../../types/AutoCompleteOptionWithValue";

const getOptions = (backofficeUsers: Array<BackofficeUser>): any[] => {
  return _.map(sortByOperationalRole(backofficeUsers), (backofficeUser) => {
    return {
      label: backofficeUser.person.fullname,
      value: backofficeUser.email,
      groupBy: getOperationalRoleToDisplay(backofficeUser),
    };
  });
};

export default function Impersonate() {
  const currentUser = useCurrentUser();
  const navigate = useNavigate();
  const [selectedUserOption, setSelectedUserOption] = useState<AutoCompleteOptionWithValue | null | undefined>(null);
  const { backofficeUsers } = useBackofficeUser();
  const queryClient = useQueryClient();

  const handleImpersonate = (impersonateUser: string | undefined) => {
    if (!impersonateUser) {
      return;
    }
    sessionStorage.setItem("impersonate", impersonateUser);
    queryClient.invalidateQueries({
      queryKey: queryKeys.all("current_user")
    }).then(() => navigate("/"));
  };

  const clearImpersonate = () => {
    sessionStorage.removeItem("impersonate");
    queryClient.invalidateQueries({
      queryKey: queryKeys.all("current_user")
    }).then();
  };

  const options = useMemo(() => {
    return getOptions(backofficeUsers);
  }, [backofficeUsers]);

  if (!userHasOneOfTheseRoles(currentUser, [Roles.admin, Roles.developer, Roles.productManager]) && !sessionStorage.getItem("impersonate")) {
    return <Navigate to={"/"} />;
  }

  if (sessionStorage.getItem("impersonate")) {
    return (
      <ContentBox headline={"Benutzeransicht beenden"}>
        <ButtonLoading variant={"contained"} onClick={() => clearImpersonate()}>
          Nutzeransicht "{currentUser.email}" beenden
        </ButtonLoading>
      </ContentBox>
    );
  }

  return (
    <ContentBox headline={"Benutzeransicht wechseln"}>
      <LegalbirdAutoComplete
        value={selectedUserOption}
        options={options}
        groupBy={(option: AutoCompleteOptionWithValue) => option.groupBy || ""}
        setValue={(_e: any, value: any) => {
          setSelectedUserOption(_.find(options, (option) => option.value === value.value));
        }}
        label={"Nutzer"}
      />
      <ButtonLoading
        variant={"contained"}
        disabled={!selectedUserOption}
        onClick={() => handleImpersonate(selectedUserOption?.value)}
      >
        Nutzeransicht {selectedUserOption?.value} starten
      </ButtonLoading>
    </ContentBox>
  );
}
